/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/credentialForm.config.json";
import { toHeaderCase } from "js-convert-case";
import { useCredId } from "../../../pages/IssueNewCredential/provider";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_CREDENTIAL_TEMPLATE_FORM } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICredentialFormMethods extends IPluginMethodMap {
  getCredentialFormProps(args: any): Promise<any>;
}

export class CredentialFormService implements IAgentPlugin {
  readonly methods: ICredentialFormMethods;

  constructor() {
    this.methods = {
      getCredentialFormProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const { id } = useCredId();
    try {
      if (client) {
        const res = await client.query({
          query: GET_CREDENTIAL_TEMPLATE_FORM,
          variables: {
            getCredentialSchemaId: id,
          },
          fetchPolicy: "network-only",
        });
        if (res?.data?.getCredentialSchema) {
          return {
            ...res?.data?.getCredentialSchema,
            credentialLogo: res?.data?.getCredentialSchema?.logo,
            credentialDescription: res?.data?.getCredentialSchema?.description,
            credentialFields:
              res?.data?.getCredentialSchema?.jsonFormat?.credential,
            submitButtonLabel: config?.submitButtonTitle,
            credentialName: this.formatName(
              res?.data?.getCredentialSchema?.name
            ),
            templateId: res?.data?.getCredentialSchema?.id,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return err;
    }
  }

  private formatFormFields(template: any) {
    let _formFields: any = [];

    Array.isArray(template) &&
      template?.length > 0 &&
      template?.map((item: any) => {
        if (item?.type === "string") {
          _formFields.push({
            ...item,
            type: "text-input",
          });
        }
      });

    return _formFields;
  }

  private formatName(name: string) {
    if (name) {
      return toHeaderCase(name);
    }
  }

  private formatFields(template: string) {
    let _fields = {};
  }
}
